import { ApplicationDataService } from './application.service'
import { environment } from '../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { AncillaryItemViewModel } from 'app/models/AncillaryItemViewModel';
import { Observable } from 'rxjs';

@Injectable()
export class AncillaryItemsDataService {
    private static _API_ENDPOINT = environment.apiEndPoint;

    constructor(
        private http: HttpClient,
        private applicationService: ApplicationDataService) { }

    public GetAllAncillaryItemForApplication(
        applicationKey: number): Observable<AncillaryItemViewModel[]> {
        return this.http
            .get<AncillaryItemViewModel[]>(
                `${AncillaryItemsDataService._API_ENDPOINT}Application/GetAllAncillaryItemForApplication?applicationKey=${applicationKey}`,
                this.applicationService.createOptions())
            .pipe(
                catchError(this.applicationService.handleError),
                map(response => <AncillaryItemViewModel[]>(response)));
    }

    public AddAncillaryItem(
        applicationKey: number,
        ancillaryItemKey: number): Observable<string | Object> {
        return this.http
            .post(
                `${AncillaryItemsDataService._API_ENDPOINT}Application/AddAncillaryItem?applicationKey=${applicationKey}`,
                ancillaryItemKey,
                this.applicationService.createOptions())
            .pipe(
                catchError(this.applicationService.handleError),
                map(response => response));
    }

    public AddAncillaryItemGroup(
        applicationKey: number,
        ancillaryItemGroupKey: number): Observable<string | Object> {
        return this.http
            .post(
                `${AncillaryItemsDataService._API_ENDPOINT}Application/AddAncillaryItemGroup?applicationKey=${applicationKey}`,
                ancillaryItemGroupKey,
                this.applicationService.createOptions())
            .pipe(
                catchError(this.applicationService.handleError),
                map(response => response));
    }

    public RemoveAncillaryItem(
        applicationKey: number,
        ancillaryItemKey: number): Observable<string | Object> {
        return this.http
            .post(
                `${AncillaryItemsDataService._API_ENDPOINT}Application/RemoveAncillaryItem?applicationKey=${applicationKey}`,
                ancillaryItemKey,
                this.applicationService.createOptions())
            .pipe(
                catchError(this.applicationService.handleError),
                map(response => response));
    }

    public RemoveAncillaryItemGroup(
        applicationKey: number,
        ancillaryItemGroupKey: number): Observable<string | Object> {
        return this.http
            .post(
                `${AncillaryItemsDataService._API_ENDPOINT}Application/RemoveAncillaryItemGroup?applicationKey=${applicationKey}`,
                ancillaryItemGroupKey,
                this.applicationService.createOptions())
            .pipe(
                catchError(this.applicationService.handleError),
                map(response => response));
    }

    public SyncAncillaryItems(
        applicationKey: number): Observable<string | Object> {
        return this.http
            .post(
                `${AncillaryItemsDataService._API_ENDPOINT}Application/SyncAncillaryItems?applicationKey=${applicationKey}`,
                null,
                this.applicationService.createOptions())
            .pipe(
                catchError(this.applicationService.handleError),
                map(response => response));
    }
}